import type { CasinoTable } from '@ps/web-casino-types';
import type { Dictionary } from 'lodash';

export const getGameDeveloperFromTables = (tables: Dictionary<CasinoTable[]>) => {
  const developers = new Set(
    Object.values(tables)
      .flat()
      .map(({ developer }) => developer)
  );

  return developers.size > 0 ? developers.values().next()?.value : '';
};
